import type { ChangeEvent, FC, FormEvent } from 'react';
import { useId, useState } from 'react';
import { isValidEmail } from '../../helpers/validators';
import type { CoHostAddFormProps } from '../../types';

const CoHostAddForm: FC<CoHostAddFormProps> = ({ disabled, onAdd }) => {
  const [email, setEmail] = useState('');
  const inputId = useId();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!(email && isValidEmail(email))) {
      setEmail('');
      return;
    }
    onAdd(email.toLowerCase());
    setEmail('');
  };

  return (
    <form className="personal-meetings-modal__cohost-form" onSubmit={handleSubmit}>
      <div className="personal-meetings-modal__form-field">
        <label className="personal-meetings-modal__field-label" htmlFor={inputId}>
          Add co-hosts
        </label>
        <div className="personal-meetings-modal__cohost-input-box">
          <input
            id={inputId}
            type="email"
            placeholder="Enter email address"
            value={email}
            onChange={handleChange}
            className="personal-meetings-modal__field-input"
            disabled={disabled}
          />
          <button
            type="submit"
            className="personal-meetings-modal__cohost-add"
            disabled={disabled || !email}
          >
            ADD
          </button>
        </div>
      </div>
    </form>
  );
};

export default CoHostAddForm;
